var finansudd = finansudd || {};

finansudd.filterEmployeesByName = function () {
    var $list = $('.employee-list');
    var $listItems = $list.find('.employee-item');

    $listItems.each(function (i, e) {
        var searchValue = $("#filterEmployeeName").val().toLowerCase();
        var $e = $(e);

        var name = $e.find(".item-title").text().toLowerCase();

        if (name.indexOf(searchValue) > -1) {
            $e.show();
        } else {
            $e.hide();
        }
    });
}

$("#filterEmployeeName").on('keyup', function () {
    finansudd.filterEmployeesByName();
});

finansudd.employees = new function () { 

    var self = this,
        $list = $('.employee-list'),
        $listItems = $list.find('.employee-item');

    function containsAll(needles, haystack) {
        for (var i = 0, len = needles.length; i < len; i++) {
            if ($.inArray(needles[i], haystack) == -1) {
                return false;
            };
        }
        return true;
    }

    this.showEmployeesOnValue = function (selector, dataValue) {
        $(selector).on('change', function () {

            var filters = [];

            $(selector).each(function () {
                var selectedValue = $(this).find('option:selected').val();
                filters.push(selectedValue);
            });

            $listItems.each(function () {

                var $this = $(this),
                    itemFilters = $this.attr(dataValue).split(",");

                if (containsAll(filters, itemFilters)) {
                    $this.fadeIn();
                    $this.removeClass('hidden-item');
                } else {
                    $this.hide();
                    $this.addClass('hidden-item');
                }

            });

        });
    };

    this.sidebarNavigation = function () {

        var $listItem = $('.employee-navigation ul > li'),
            $select = $('select#filterid-3129');

        $listItem.click(function () {
            var $this = $(this),
                dataValue = $this.attr('data-value'),
                $preSelectedOption = $select.find('option:selected'),
                $option = $select.find('option[value="' + dataValue + '"]');

                // Apply and remove selected class on html-select
                $this.addClass('selected');
                $listItem.not($this).removeClass('selected');

                // Reset the select
                $preSelectedOption.prop('selected', false);

                if(dataValue != 0) {
                    // Set the value
                    $option.prop('selected', true).change();
                } else {
                    $select.change();
                }


        });

    };
};